// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPaymentDetailsStyles } from "@sc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.form = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    offsetCss: css`
        &&& {
            justify-content: space-between;
            padding: 16px;
            gap: 24px;
        }
    `,
};
onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText = {
    variant: "h3",
    forwardAs: "h2",
    css: css`
        margin-bottom: 0;
    `,
};
onePageCheckoutPaymentDetailsStyles.paymentDetailsGridContainer = {
    gap: 16,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodGridItem = {
    width: 12,
    css: css`
        &&& {
            max-width: calc((100% - 135px) / 2);
            padding: 0;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        }
        flex-direction: column;
    `,
};

onePageCheckoutPaymentDetailsStyles.poNumberGridItem = {
    width: 12,
    css: css`
        &&& {
            max-width: calc((100% - 135px) / 2);
            padding: 0;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        }
        flex-direction: column;
    `,
};
